import { ChatGateway } from './chat-gateway.interface';

export const initChatAPI = (apiSlice: any, gateway: ChatGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Chat'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getChatByProject: builder.query({
          query: gateway.getChatByProject,
          providesTags: ['Chat'],
        }),
        postChatMessage: builder.mutation({
          query: gateway.postMessage,
          invalidatesTags: ['Chat'],
        }),
        deleteChatMessage: builder.mutation({
          query: gateway.deleteMessage,
          invalidatesTags: ['Chat'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface ChatSliceType {
  useGetChatByProjectQuery: Function;
  useLazyGetChatByProjectQuery: Function;
  usePostChatMessageMutation: Function;
  useDeleteChatMessageMutation: Function;
}
